interface StoreVariableConfigProps {
  config: Record<string, unknown>;
  onChange: (config: Record<string, unknown>) => void;
}

export function StoreVariableConfig({ config, onChange }: StoreVariableConfigProps) {
  const name = (config.name as string) || '';
  const value = (config.value as string) || '';

  return (
    <div className="space-y-4">
      <p className="text-xs text-base-content/60">
        <span className="font-medium">Stored scope:</span> persisted for this endpoint and shared across requests.
        Read it in templates as <code>{'{{vars.name}}'}</code>.
      </p>
      <div className="fieldset">
        <label className="fieldset-legend">Variable Name</label>
        <input
          type="text"
          value={name}
          onChange={(e) => onChange({ ...config, name: e.target.value })}
          placeholder="persistentVar"
          className="input w-full"
        />
      </div>

      <div className="fieldset">
        <label className="fieldset-legend">Value</label>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange({ ...config, value: e.target.value })}
          placeholder="Hello {{request.method}}"
          className="input w-full"
        />
        <p className="label whitespace-normal text-base-content/80">Stored variables persist across requests</p>
      </div>
    </div>
  );
}
